import { api } from '../../../services/api/client';
import type { IndicatorEligibility, IndicatorRequest } from '../../../types';

// Member
export async function fetchEligibility(): Promise<IndicatorEligibility> {
  const { data } = await api.get<IndicatorEligibility>('/member/indicator-access/eligibility');
  return data;
}
export async function fetchMyRequests(): Promise<IndicatorRequest[]> {
  const { data } = await api.get<IndicatorRequest[]>('/member/indicator-access/requests');
  return data;
}
export async function createRequest(tradingview_username: string): Promise<IndicatorRequest> {
  const { data } = await api.post<IndicatorRequest>('/member/indicator-access/requests', { tradingview_username });
  return data;
}
export async function updateRequest(id: string, tradingview_username: string): Promise<IndicatorRequest> {
  const { data } = await api.put<IndicatorRequest>(`/member/indicator-access/requests/${id}`, { tradingview_username });
  return data;
}
export async function requestChange(tradingview_username: string): Promise<IndicatorRequest> {
  const { data } = await api.post<IndicatorRequest>('/member/indicator-access/requests/change', { tradingview_username });
  return data;
}
export interface IndicatorLog { id: string; tradingview_username: string; action: string; note: string; created_at: string; }
export async function fetchHistory(): Promise<IndicatorLog[]> {
  const { data } = await api.get<IndicatorLog[]>('/member/indicator-access/history');
  return data;
}

// Admin
export async function adminFetchRequests(): Promise<IndicatorRequest[]> {
  const { data } = await api.get<IndicatorRequest[]>('/admin/indicator-access/requests');
  return data;
}
export async function adminProcessRequest(id: string, status: string, admin_note: string): Promise<IndicatorRequest> {
  const { data } = await api.post<IndicatorRequest>(`/admin/indicator-access/requests/${id}/process`, { status, admin_note });
  return data;
}
export async function adminRevokeRequest(id: string, note: string): Promise<IndicatorRequest> {
  const { data } = await api.post<IndicatorRequest>(`/admin/indicator-access/requests/${id}/revoke`, { note });
  return data;
}
export async function adminDeleteRequest(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/indicator-access/requests/${id}`);
  return data;
}
